import ResetSendEmailContainer from '../../../../Containers/AdminContainer/Auth/ResetPassword/sendEmail';

const ResetSendEmailScreen = () => {
  return <ResetSendEmailContainer />;
};
export default ResetSendEmailScreen;
